import { Logo } from "@/components/common";

export default function AuthLayout({ children }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="flex flex-col items-center justify-center gap-6 bg-[#FAF7F2] px-4 py-10">
        <div className="lg:hidden"><Logo /></div>
        <div dir="ltr" data-testid="clerk-auth-container">{children}</div>
        <p className="max-w-sm text-center text-xs text-[#5C7067]">
          بعد إنشاء الحساب ستختار مشروعك ورقم وحدتك، ويتم تفعيل الخدمات بعد اعتماد إدارة دارنا.
        </p>
      </div>
      <div className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-[#0F382C] p-12 text-white">
        <img src="/images/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="relative"><Logo light /></div>
        <div className="relative max-w-md">
          <h2 className="text-4xl font-extrabold leading-tight">بيتك ومجمعك<br /><span className="text-[#C59B27]">في مكان واحد</span></h2>
          <p className="mt-4 text-white/75">خدمات الصيانة المشتركة ومتجر الخدمات المنزلية لملاك المشاريع السكنية المتعاقدة.</p>
        </div>
        <div className="relative pattern-bg h-16 rounded-xl opacity-60" />
      </div>
    </div>
  );
}
